export var reviews = [
  {
    id: 1,
    name: "Erwin Maus",
    badge: "Local Guide",
    stats: "224 Rezensionen · 9 Fotos",
    timeAgo: "vor einem Jahr",
    rating: 5,
    text: "Unglaublich tolle Firma, sehr gute Mitarbeiter, wie der Inhaber, alle fachlich sehr kompetent. Auch in schwierigen und zeitlich kritischen Situationen gaben alle Ihr absolut bestes und haben Ziel- und Lösungsorientiert die gestellten Aufgaben umgesetzt. Eine Firma, die gestellte Aufgaben einfach umsetzt und man sich um nichts mehr kümmern muss. Kann ich uneingeschränkt empfehlen!"
  },
  {
    id: 2,
    name: "Damian",
    badge: null,
    stats: "4 Rezensionen",
    timeAgo: "vor einem Jahr",
    rating: 5,
    text: "Ich bin absolut begeistert von der Arbeit dieses Elektriker-Teams! Von der ersten Kontaktaufnahme bis zur Fertigstellung der Arbeiten war alles perfekt. Die Kommunikation war stets freundlich und professionell, und meine Fragen wurden ausführlich beantwortet. Der Elektriker erschien pünktlich, war gut vorbereitet und hat sehr sauber gearbeitet. Besonders beeindruckt hat mich die Präzision und Effizienz, mit der die Arbeiten ausgeführt wurden."
  },
  {
    id: 3,
    name: "Florian Zirngibl",
    badge: null,
    stats: "2 Rezensionen",
    timeAgo: "vor 9 Monaten",
    rating: 5,
    text: "Absolute Empfehlung! Die Mitarbeiter sind super freundlich, pünktlich und leisten tolle Arbeit. Außerdem bekommt man eine ehrliche Beratung. Es wurde nichts unnötig gemacht, sondern nur das, was wirklich sinnvoll und nötig war. Immer wieder gerne!"
  },
  {
    id: 4,
    name: "Max Zenner",
    badge: "Local Guide",
    stats: "53 Rezensionen · 43 Fotos",
    timeAgo: "vor einem Jahr",
    rating: 5,
    text: "Elektro Fesch hat bei uns hervorragende Arbeit geleistet. Die Beratung war kompetent und die Umsetzung schnell und professionell. Das Team ist freundlich und zuverlässig. Klare Empfehlung!"
  },
  {
    id: 5,
    name: "Paul Madaj",
    badge: null,
    stats: "6 Rezensionen · 3 Fotos",
    timeAgo: "vor einem Jahr",
    rating: 5,
    text: "Ein junger, engagierter und technisch sehr versierter Unternehmer, auf den man sich immer verlassen kann."
  },
  {
    id: 6,
    name: "Igwe Justin",
    badge: null,
    stats: "3 Rezensionen · 3 Fotos",
    timeAgo: "vor einem Jahr",
    rating: 5,
    text: "Ich könnte nicht zufriedener sein mit dem außergewöhnlichen Service von Fesch während der Renovierung unserer Hauselektrik und dem Upgrade zu einem kompletten Smart-Home-System. Von Anfang bis Ende war ihr Engagement und ihre Expertise in jedem Aspekt des Projekts erkennbar. Sie haben nicht nur die technischen Aspekte einwandfrei umgesetzt, sondern uns auch wertvolle Ratschläge gegeben, die meiner Frau und mir geholfen haben, fundierte Entscheidungen zu treffen."
  }
];
